// Header.jsx
import React from "react";
import "./Header.css";

export default function Header({ onOpenContact }) {
  return (
    <header className="header-container">
      <div className="header-content">
        <div className="logo-wrapper">
          <img
            src="https://arely-media.s3.us-east-1.amazonaws.com/IMG_20250125_220734.jpg"
            alt="ARELY CONSTRUCTION & PAINTING LLC Logo"
            className="header-logo"
          />
        </div>
        <nav className="nav-menu">
          <a href="#hero" className="nav-link">Home</a>
          <a href="#services" className="nav-link">Services</a>
          <a href="#image-gallery" className="nav-link">Gallery</a>
          <a href="#video-gallery" className="nav-link">Videos</a>
          <button onClick={onOpenContact} className="contact-button">Contact Us</button>
        </nav>
      </div>
    </header>
  );
}
